<!-- Start Page Header -->
<div class="page-header">
    <div class="container">
        <div class="row">
            <div class="col-md-12">

                <h2 class="entry-title">
                    {{
                        getArticleTitle() ||
                        ('articleDetails' | translate)
                    }}
                </h2>

                <div class="breadcrumb">

                    <span>
                        {{ 'here' | translate }} :
                    </span>

                    <a routerLink="/Home">
                        {{ 'home' | translate }}
                    </a>

                    <span class="crumbs-spacer">
                        <i
                            class="fa"
                            [ngClass]="
                                currentLang === 'ar'
                                    ? 'fa-angle-double-left'
                                    : 'fa-angle-double-right'
                            ">
                        </i>
                    </span>

                    <a routerLink="/Articles">
                        {{ 'articles' | translate }}
                    </a>

                    <ng-container *ngIf="article">

                        <span class="crumbs-spacer">
                            <i
                                class="fa"
                                [ngClass]="
                                    currentLang === 'ar'
                                        ? 'fa-angle-double-left'
                                        : 'fa-angle-double-right'
                                ">
                            </i>
                        </span>

                        <span class="current">
                            {{ getArticleTitle() }}
                        </span>

                    </ng-container>

                </div>
            </div>
        </div>
    </div>
</div>
<!-- End Page Header -->


<!-- Start Article Details -->
<section
    id="content"
    class="article-details-section">

    <div class="container">

        <!-- Loading -->
        <div
            class="article-state"
            *ngIf="isLoading">

            <i class="fa fa-spinner fa-spin"></i>

            <p>
                {{ 'loadingArticle' | translate }}
            </p>

        </div>


        <!-- Error -->
        <div
            class="article-error"
            *ngIf="!isLoading && errorMessage">

            <i class="fa fa-exclamation-circle"></i>

            <h3>
                {{ 'articleLoadingError' | translate }}
            </h3>

            <p>
                {{ errorMessage }}
            </p>

            <div class="error-actions">

                <button
                    type="button"
                    class="btn btn-effect"
                    (click)="retryLoading()">

                    <i class="fa fa-refresh"></i>

                    {{ 'tryAgain' | translate }}

                </button>

                <button
                    type="button"
                    class="btn back-button"
                    (click)="goToArticles()">

                    <i
                        class="fa"
                        [ngClass]="
                            currentLang === 'ar'
                                ? 'fa-arrow-right'
                                : 'fa-arrow-left'
                        ">
                    </i>

                    {{ 'backToArticles' | translate }}

                </button>

            </div>

        </div>


        <!-- Article -->
        <article
            class="article-details"
            *ngIf="
                !isLoading &&
                !errorMessage &&
                article
            "
            [attr.dir]="
                currentLang === 'ar'
                    ? 'rtl'
                    : 'ltr'
            ">

            <div class="row">

                <!-- Main Article -->
                <div class="col-md-9">

                    <div class="article-main">

                        <!-- Image -->
                        <div class="article-featured-image">

                            <img
                                [src]="getArticleImage()"
                                [alt]="getArticleTitle()"
                                (error)="handleImageError($event)" />

                        </div>


                        <!-- Meta Information -->
                        <div class="article-meta">

                            <span *ngIf="article.publishedDate">

                                <i class="fa fa-calendar"></i>

                                {{
                                    article.publishedDate
                                        | date:'dd MMMM yyyy'
                                }}

                            </span>

                            <span *ngIf="article.author">

                                <i class="fa fa-user"></i>

                                {{ article.author }}

                            </span>

                            <span *ngIf="article.sourceSystemName">

                                <i class="fa fa-globe"></i>

                                {{ article.sourceSystemName }}

                            </span>

                        </div>


                        <!-- Title -->
                        <h1 class="article-details-title">
                            {{ getArticleTitle() }}
                        </h1>


                        <!-- Summary -->
                        <div
                            class="article-summary-box"
                            *ngIf="getArticleSummary()">

                            {{ getArticleSummary() }}

                        </div>


                        <!-- HTML Body -->
                        <div
                            class="article-body"
                            [attr.dir]="
                                currentLang === 'ar'
                                    ? 'rtl'
                                    : 'ltr'
                            "
                            [innerHTML]="articleHtml">
                        </div>

                    </div>

                </div>


                <!-- Sidebar -->
                <div class="col-md-3">

                    <aside class="article-sidebar">

                        <h2 class="big-title">
                            {{ 'articleInformation' | translate }}
                        </h2>


                        <div class="sidebar-information">

                            <!-- Publish Date -->
                            <div
                                class="information-item"
                                *ngIf="article.publishedDate">

                                <i class="fa fa-calendar"></i>

                                <div>

                                    <strong>
                                        {{ 'publishDate' | translate }}
                                    </strong>

                                    <span>
                                        {{
                                            article.publishedDate
                                                | date:'dd MMMM yyyy'
                                        }}
                                    </span>

                                </div>

                            </div>


                            <!-- Author -->
                            <div
                                class="information-item"
                                *ngIf="article.author">

                                <i class="fa fa-user"></i>

                                <div>

                                    <strong>
                                        {{ 'author' | translate }}
                                    </strong>

                                    <span>
                                        {{ article.author }}
                                    </span>

                                </div>

                            </div>


                            <!-- Status -->
                            <div
                                class="information-item"
                                *ngIf="article.statusName">

                                <i class="fa fa-check-circle"></i>

                                <div>

                                    <strong>
                                        {{ 'status' | translate }}
                                    </strong>

                                    <span>
                                        {{ article.statusName }}
                                    </span>

                                </div>

                            </div>


                            <!-- Source -->
                            <div
                                class="information-item"
                                *ngIf="article.sourceSystemName">

                                <i class="fa fa-globe"></i>

                                <div>

                                    <strong>
                                        {{ 'source' | translate }}
                                    </strong>

                                    <span>
                                        {{ article.sourceSystemName }}
                                    </span>

                                </div>

                            </div>

                        </div>


                        <button
                            type="button"
                            class="back-to-articles"
                            (click)="goToArticles()">

                            <i
                                class="fa"
                                [ngClass]="
                                    currentLang === 'ar'
                                        ? 'fa-long-arrow-right'
                                        : 'fa-long-arrow-left'
                                ">
                            </i>

                            {{ 'backToArticles' | translate }}

                        </button>

                    </aside>

                </div>

            </div>

        </article>

    </div>
</section>
<!-- End Article Details -->